import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Pill extends Component {
    render() {
        const {children, color, style} = this.props;

        const bgColor = classNames({
            'pill': true,
            'bg-success': color === 'success',
            'bg-info': color === 'info',
            'bg-warning': color === 'warning',
            'bg-danger': color === 'danger'
        });

        return (
            <div className={bgColor} style={style}>
                {children}
            </div>
        );
    }
}

Pill.propTypes = {
    children: PropTypes.any.isRequired,
    color: PropTypes.string,
    style: PropTypes.object,
};

export default Pill;


// WEBPACK FOOTER //
// ./src/components/display/Pill.js